import { AssetManager } from 'src/app/asset-manager/asset-manager';
import { Modes } from "../Framework/mode";
import { Region } from "../Framework/Region";
import { DocumentResource } from "../ResourceElements/document";
import { Collection } from "./Collection";
import { MatSnackBar } from '@angular/material/snack-bar';

export class DocumentsCollection extends Collection {

    private _assetDocuments: Array<DocumentResource> = new Array<DocumentResource>();
    public get assetDocuments(): Array<DocumentResource> {
        return this._assetDocuments;
    }
    public set assetDocuments(v: Array<DocumentResource>) {
        this._assetDocuments = v;
    }

    public isVisible: boolean = false

    constructor(
        private assetManager: AssetManager,
        private snackBar: MatSnackBar,
    ) {
        super(null);
        this.isGroupRecursive = false;
        this.Type = "DocumentCampaign";
    }

    public addDocument(document: DocumentResource): void {
        switch (document.documentMode) {
            case 'MODEL':
                this.assetDocuments.push(document);
                break;
            case 'REGIONS':
                if (document.documentMediaModel.RegionId) {
                    const region = this.regionsWorkableElements.find(x => x.Guid === document.documentMediaModel.RegionId);
                    if (region) {
                        region.regionsDocuments.push(document);
                    }
                }
                else {
                    for (const regionId of document.documentMediaModel.RegionIds) {
                        const region = this.regionsWorkableElements.find(x => x.Guid === regionId);
                        if (region) {
                            region.regionsDocuments.push(document);
                        }
                    }
                }
                break;
            case 'SECTIONS':
                {
                  var documentHasRegionReference = document.documentMediaModel.RegionId
                    || document.documentMediaModel.RegionIds?.length > 0;

                  for (const region of this.regionsWorkableElements) {
                    var documentReferencesRegion = region.Guid === document.documentMediaModel.RegionId
                      || document.documentMediaModel.RegionIds?.includes(region.Guid);

                    if (document.documentMediaModel.SectionId) {
                      const sectionDocs = region.sections.find(x => x.Guid === document.documentMediaModel.SectionId);
                      if (sectionDocs && (!documentHasRegionReference || documentReferencesRegion)) {
                        sectionDocs.sectionDocuments.push(document);
                      }
                    }
                    else if (document.documentMediaModel.SectionIds) {
                      for (const sectionId of document.documentMediaModel.SectionIds) {
                        const sectionDocs = region.sections.find(x => x.Guid === sectionId);
                        if (sectionDocs && (!documentHasRegionReference || documentReferencesRegion)) {
                          sectionDocs.sectionDocuments.push(document);
                        }
                      }
                    }
                  }
                }
                break;
            default:
                break;
        }
    }

    public async showDocuments(regions: Array<Region>, mode: Modes): Promise<void> {
        switch (mode) {
            case 'MODEL':
                if (this.assetDocuments.length == 0) {
                    this.snackBar.open('No documents available for this Asset', '', {
                        horizontalPosition: 'center',
                        verticalPosition: 'bottom',
                        duration: 3000
                    });
                    return
                }
                this.assetManager.setDocumentsList(this.assetDocuments)
                break;
            case 'REGIONS':
                for (const region of regions) {
                    const visibleRegion = this.regionsWorkableElements.find(x => x.Guid === region.Guid);
                    if (!visibleRegion) continue;

                    if (visibleRegion.regionsDocuments.length === 0) {
                        this.snackBar.open('No documents available for this Region', '', {
                            horizontalPosition: 'center',
                            verticalPosition: 'bottom',
                            duration: 3000
                        });
                        return;
                    }

                    this.snackBar.open('Click in a document icon to view a document.', '', {
                        horizontalPosition: 'center',
                        verticalPosition: 'bottom',
                        duration: 6000
                    });

                    this.assetManager.setDocumentsList(visibleRegion.regionsDocuments);
                }
                break;
            case 'SECTIONS':
                for (const region of regions) {
                    if (!region.isStructural) continue;

                    const visibleRegion = this.regionsWorkableElements.find(x => x.Guid === region.Guid);
                    if (!visibleRegion) continue;

                    for (const section of region.sections) {
                        if (!section.visible) continue;

                        const visibleSection = visibleRegion.sections.find(x => x.Guid === section.Guid);
                        if (!visibleSection) continue;

                        if (visibleSection.sectionDocuments.length === 0) {
                            this.snackBar.open('No documents available for this Section', '', {
                                horizontalPosition: 'center',
                                verticalPosition: 'bottom',
                                duration: 3000
                            });
                            return;
                        }

                        this.snackBar.open('Click in a document icon to view a document.', '', {
                            horizontalPosition: 'center',
                            verticalPosition: 'top',
                            duration: 6000
                        });

                        this.assetManager.setDocumentsList(visibleSection.sectionDocuments);
                    }
                }
                break;
            default:
                break;
        }
        this.isVisible = true
    }

    public hideDocuments(): void {
        this.isVisible = false
    }
}
